import { useState } from 'react';
import { createPortal } from 'react-dom';
import { PAPER_LIST } from '../lib/paper.js';

/* 换纸（10-05 铃）：纸右上角一个不显眼的线条小图标（一叠纸），颜色跟纸上的字一样；
   点开底下滑出一排缩略图，第一个「按心情」= 回到自动挑的那张。
   value = 现在铺的纸；chosen = 她亲手选的（没选过为 null）；onPick(纸名 | null)。 */
export default function PaperPicker({ value, chosen, onPick }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className="dr-paper-btn"
        onClick={(ev) => {
          ev.stopPropagation();
          setOpen((o) => !o);
        }}
        aria-label="换一张纸"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 3.5h9l3.5 3.5v13.5H7z" />
          <path d="M16 3.5V7h3.5" />
          <path d="M4.5 6.5v15h11" />
        </svg>
      </button>
      {/* 托盘挂到 body：纸带 filter/动画，fixed 会被困在纸里；触摸不往外冒，免得左右滑托盘时翻了页 */}
      {open && createPortal(
        <div
          className="dr-tray-scrim"
          onClick={() => setOpen(false)}
          onTouchStart={(ev) => ev.stopPropagation()}
          onTouchEnd={(ev) => ev.stopPropagation()}
        >
          <div className="dr-tray" onClick={(ev) => ev.stopPropagation()} role="listbox" aria-label="换纸">
            <button
              type="button"
              className={'dr-tray-auto' + (!chosen ? ' on' : '')}
              onClick={() => {
                onPick(null);
                setOpen(false);
              }}
            >
              <span>✦</span>
              按心情
            </button>
            {PAPER_LIST.map(([k, name]) => (
              <button
                key={k}
                type="button"
                className={'dr-tray-item' + (chosen && value === k ? ' on' : '')}
                onClick={() => {
                  onPick(k);
                  setOpen(false);
                }}
              >
                <img src={`/img/paper/thumb/${k}.webp?v=1`} alt="" loading="lazy" />
                {name}
              </button>
            ))}
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
